/**
 *
 * Basic validation of Doc Path
 * @param {string} path - Path string to validate
 * @returns {object} validPath {boolean} and path {string}
 */
export function validateCollectionPath(path: string) {
  // Remove extra '/'
  if (path.startsWith('/'))
    path = path.substring(1)
  if (path.endsWith('/'))
    path = path.substring(0, path.length - 1)

  // Check path length as a valid path for a single doc
  const validPathArr = path.split('/')
  const validPath = (validPathArr.length % 2) === 1

  return {
    validPath,
    path
  }
}
